import gql from 'graphql-tag';
import { scheduledSessionFieldsFragment } from '../fragments';

export const pauseScheduledSessionMutation = gql`
  mutation PauseScheduledSession($id: ID!) {
    pauseScheduledSession(id: $id) {
      ...AdminScheduledSessionFields
    }
  }

  ${scheduledSessionFieldsFragment}
`;
